<template>
    <v-col cols="12">
      <v-form @submit.prevent="save" lazy-validation v-model="valid" ref="form">
        <v-card tile class="mx-1">
          <v-card-title>
            <p> {{ titulo }} </p>
          </v-card-title>
          <v-card-subtitle>
            Espaço reservado para posicionamento da Comissão (Nome da Comissão) sobre o monitoramento, após manifestação da OSC (Nome da organização).
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
          <v-row>
            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">A Comissão considera o monitoramento:</span>
              <v-radio-group v-model="parecer">
                <v-radio
                  label="Solicitamos esclarecimentos"
                  value="SOLICITAMOS_ESCLARECIMENTOS"
                ></v-radio>
                <v-radio
                  label="Reprovado"
                  value="REPROVADO"
                ></v-radio>
                <v-radio
                  label="Aprovado com ressalvas"
                  value="APROVADO_RESSALVAS"
                ></v-radio>
                <v-radio
                  label="Aprovado"
                  value="APROVADO"
                ></v-radio>
              </v-radio-group>
            </v-col>
              <v-col cols="12" class="mb-n3">
                <v-textarea
                  v-model="observacoes"
                    label="Observações da Comissão sobre o Parecer"
                    filled
                    rows="3"
                    auto-grow
                    :rules="[(v) => !!v || 'Preencha o campo Observações da Comissão sobre o Parecer.']"
                ></v-textarea>
              </v-col>
              <v-col cols="12" class="mt-n4">
                <v-file-input
                  small-chips
                  multiple
                  label="Arquivo"
                  v-model="file"
                ></v-file-input>
              </v-col>

          </v-row>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mx-1 py-6">
            <v-btn type="submit" color="success text-center" small>{{ isUpdate ? "Salvar alterações" : "Salvar" }}</v-btn>
            <v-btn @click.prevent="cancel" color="error text-center" small>Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
</template>

<script>
import {mapActions} from "vuex";

export default {
  props: {
    prestacaoConta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parecer: this.prestacaoConta.parecer,
      observacoes: this.prestacaoConta.observacoesComissao,
      file: null,
      valid: true,
      errorMessage: "",
      dataFormatada: '',
      menu1: false,
    };
  },
  computed: {
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },
    isUpdate() {
      return !!this.prestacaoConta.parecer;
    },
    titulo() {
      return this.isUpdate ? "Editar Posição da Comissão da Requerente" : "Posição Comissão da Requerente" 
    },
  },
  methods: {
    ...mapActions('prestacaoConta', ['realizarParecer']),

    save() {
      if(this.$refs.form.validate()) {
        this.persist().then((formulario) => {
          this.$refs.form.resetValidation()
          this.$emit("save", { formulario });
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },

    persist() {
      return this.create();
    },

    create() {
      const payload = {
        "projetoId": this.prestacaoConta.projeto.id,
        "prestacaoContaId": this.prestacaoConta.id,
        "parecer": this.parecer,
        'observacoes': this.observacoes,
        'file': this.file ? this.file[0] : null 
      }
      
      return this.realizarParecer(payload)
    },
    
    cancel() {
      this.$refs.form.reset();
      this.$emit("cancel");
    },
  }, 
};
</script>

<style scoped>
</style>
